import styled, { css } from 'styled-components';
import { flexCenterVertical, flexColumnCenter } from '@stylesheets/helpers';

export { Logo, BrandName } from '../Login/Login.styled';

export const Wrapper = styled.div`
  width: 100%;
  height: 100vh;
  position: relative;
  overflow: hidden;
  ${flexColumnCenter}

  ${({ theme: { colors } }) => css`
    background: ${colors?.surfaceContainerLowest};
    color: ${colors?.onSurface};
  `}

  @media (max-width: 768px) {
    height: auto;
    min-height: 100vh;
    overflow-y: auto;
    align-items: flex-start;

    ${({ theme: { spacing } }) => css`
      padding: ${spacing?.level7} ${spacing?.level5};
    `}
  }
`;

export const Background = styled.div`
  position: absolute;
  inset: 0;
  background: url('/img/landing/landing-background.png') calc(100% + 410px) center / auto 110%
    no-repeat;
  opacity: 0.65;
  filter: brightness(0.6) saturate(0.8);

  ${({ theme: { colors } }) => css`
    &::after {
      content: '';
      position: absolute;
      inset: 0;
      background: radial-gradient(
        ellipse at 80% 50%,
        transparent 20%,
        ${colors?.surfaceContainerLowest} 90%
      );
    }
  `}
`;

export const Header = styled.div`
  ${flexCenterVertical}
  position: absolute;

  ${({ theme: { spacing } }) => css`
    top: ${spacing?.level7};
    left: ${spacing?.level8};
    gap: ${spacing?.level3};
  `}

  @media (max-width: 768px) {
    position: relative;
    top: unset;
    left: unset;
    align-self: flex-start;

    ${({ theme: { spacing } }) => css`
      margin-bottom: ${spacing?.level5};
    `}
  }
`;

export const Content = styled.div`
  position: relative;
  z-index: 1;
  text-align: center;
  ${flexColumnCenter}
  width: 100%;

  ${({ theme: { spacing } }) => css`
    max-width: 800px;
    padding: 0 ${spacing?.level6};
  `}

  @media (max-width: 768px) {
    ${({ theme: { spacing } }) => css`
      padding: 0 ${spacing?.level5};
    `}
  }
`;

export const Badge = styled.div`
  ${({ theme: { colors, font, spacing, borderRadius } }) => css`
    display: inline-flex;
    align-items: center;
    gap: ${spacing?.level3};
    padding: ${spacing?.level3} ${spacing?.level5};
    background: ${colors?.primaryContainer}1F;
    border: 1px solid ${colors?.primaryContainer}33;
    border-radius: ${borderRadius?.full};
    ${font?.labelLarge}
    color: ${colors?.primary};
    margin-bottom: ${spacing?.level8};

    &::before {
      content: '';
      width: 8px;
      height: 8px;
      background: ${colors?.primaryContainer};
      border-radius: 50%;
    }

    @media (max-width: 768px) {
      margin-bottom: ${spacing?.level6};
    }
  `}
`;

export const Headline = styled.h1`
  ${({ theme: { font, colors, spacing } }) => css`
    ${font?.displayLarge}
    font-weight: 700;
    line-height: 1.1;
    letter-spacing: -1.5px;
    color: ${colors?.onSurface};
    margin: 0 0 ${spacing?.level7};

    @media (max-width: 768px) {
      ${font?.displaySmall}
      font-weight: 700;
    }
  `}
`;

export const HighlightText = styled.span`
  ${({ theme: { colors } }) => css`
    background: linear-gradient(
      135deg,
      ${colors?.primary} 0%,
      ${colors?.tertiary} 50%,
      ${colors?.primary} 100%
    );
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  `}
`;

export const Subtitle = styled.p`
  ${({ theme: { font, colors, spacing } }) => css`
    ${font?.titleLarge}
    font-weight: 400;
    color: ${colors?.onSurfaceVariant};
    margin: 0 0 ${spacing?.level3};
  `}

  @media (max-width: 768px) {
    ${({ theme: { font } }) => css`
      ${font?.titleMedium}
      font-weight: 400;
    `}
  }
`;

export const SubtitleSecondary = styled.p`
  ${({ theme: { font, colors, spacing } }) => css`
    ${font?.bodyLarge}
    color: ${colors?.outline};
    margin: 0 0 ${spacing?.level9};
  `}

  @media (max-width: 768px) {
    ${({ theme: { spacing } }) => css`
      margin-bottom: ${spacing?.level7};
    `}
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: center;

  ${({ theme: { spacing } }) => css`
    gap: ${spacing?.level5};
  `}

  @media (max-width: 480px) {
    flex-direction: column;
    align-items: stretch;
    width: 100%;
  }
`;
